<div class="full-screen d-flex align-items-center pt-30 pb-30 pt-lg-0 pb-lg-0">
    <div class="container-fluid">
        <div class="row justify-content-lg-start justify-content-center">
            <div class="col-lg-2 d-none d-lg-block"></div>
            <div class="col-12 col-lg-10">
                <div class="brk-form brk-form-strict maxw-570 mx-auto mx-lg-0 text-center text-lg-left"
                    data-brk-library="component__form">

                    <h1
                        class="font__family-montserrat font__weight-bold font__size-42 line__height-42 mt-0 mb-35 text-center text-lg-left">
                        Ocorreu um erro ao carregar a eleição</h1>
                    <div class="generic-error-illustration mb-30 text-center text-lg-left" aria-hidden="true">
                        <svg viewBox="0 0 420 250" role="img" class="generic-error-illustration__svg">
                            <defs>
                                <linearGradient id="genSkyGradient" x1="0" y1="0" x2="0" y2="1">
                                    <stop offset="0%" stop-color="#f7fbf4"></stop>
                                    <stop offset="55%" stop-color="#e6f0df"></stop>
                                    <stop offset="100%" stop-color="#d5e6cc"></stop>
                                </linearGradient>
                                <linearGradient id="genGroundGradient" x1="0" y1="0" x2="0" y2="1">
                                    <stop offset="0%" stop-color="#dbe8d3"></stop>
                                    <stop offset="100%" stop-color="#bfd2b2"></stop>
                                </linearGradient>
                                <clipPath id="genSceneClip">
                                    <rect x="0" y="0" width="420" height="250" rx="24"></rect>
                                </clipPath>
                            </defs>
                            <g clip-path="url(#genSceneClip)">
                                <rect x="0" y="0" width="420" height="250" rx="24" fill="url(#genSkyGradient)"></rect>
                                <path d="M0 170C60 148 130 146 206 156C286 167 349 157 420 144V250H0Z"
                                    fill="url(#genGroundGradient)"></path>
                                <rect x="122" y="78" width="176" height="112" rx="16" fill="#f6fbf3" stroke="#8da980" stroke-width="4"></rect>
                                <circle cx="210" cy="123" r="32" fill="#fff9e6" stroke="#cfb05c" stroke-width="4"></circle>
                                <path d="M210 106V129" stroke="#a48740" stroke-width="7" stroke-linecap="round"></path>
                                <circle cx="210" cy="142" r="4" fill="#a48740"></circle>
                                <path d="M155 176H266" stroke="#7c9a72" stroke-width="6" stroke-linecap="round" opacity="0.85"></path>
                            </g>
                        </svg>
                    </div>
                    <div class="alert alert-clean fade alert-warning text-left font__family-montserrat font__size-16 font__weight-light brk-library-rendered rendered show"
                        role="alert" data-brk-library="component__alert">
                        <i class="start-icon far fa-exclamation-triangle"></i>
                        <strong class="font__weight-semibold">Não foi possível concluir a operação.</strong>
                        Tente novamente em alguns instantes. Se o problema persistir, entre em contato com o suporte
                        informando o horário do ocorrido.
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
